export default {
  'CONTACT.REPORT.SUB.TITLE': 'Contact dashboard',
  'CONTACT.REPORT.FILTER.MODIFIED.DESC': 'Filter has been updated',
  'CONTACT.REPORT.FILTERS': 'Filter',
  'CONTACT.REPORT.FILTERS.BLOCK.L': 'Exclude contacts from <span> </span>',
  'CONTACT.REPORT.FILTERS.BLOCK.C': 'Blocklist',
  'CONTACT.REPORT.FILTERS.BLOCK.R':
    '<span> </span>and <a href="{url}" target="_blank" style="text-decoration: none;">SLHP</a>',
  'CONTACT.REPORT.FILTERS.MY': 'My filter',
  'CONTACT.REPORT.FILTERS.MY.EDIT': 'Edit Filter',
  'CONTACT.REPORT.FILTERS.MY.NO.DATA': 'No filter here',
  'CONTACT.REPORT.FILTERS.MY.DEL.TITLE': 'Are you sure to delete the filter?',
  'CONTACT.REPORT.FILTERS.MY.DEL.DESC':
    "Filter <b class='color-333'>'<span>{name}</span>'</b> will be permanently deleted and cannot be restored.",
  'CONTACT.REPORT.FILTERS.DATE.PRESETS': 'Last {num} days',
  'CONTACT.REPORT.FILTERS.DATE.PRESETS.ALL': 'All',
  'CONTACT.REPORT.FILTERS.MY.NO.SOURCE': 'No source here',
  'CONTACT.REPORT.FILTERS.PREFERENCE': 'Preference',
  'CONTACT.REPORT.FILTERS.MY.NO.PREFERENCE': 'No preference here',
  'CONTACT.REPORT.FILTERS.PREFERENCE.EMPTY.TEXT':
    'No preference here, Please create',
  'CONTACT.REPORT.FILTERS.PREFERENCE.CREATE': 'Create preference',
  'CONTACT.REPORT.FILTERS.MY.NO.RATING': 'No Engagement here',
  'CONTACT.REPORT.FILTERS.REGION': 'Regions',
  'CONTACT.REPORT.FILTERS.MY.NO.REGION': 'No Regions here',
  'CONTACT.REPORT.FILTERS.REGION.CUSTOM.AREA.GROUP.TITLE': 'Zone',
  'CONTACT.REPORT.FILTERS.REGION.GROUP.TITLE': 'Regions',
  'CONTACT.REPORT.FILTERS.REGION.GO.L':
    "Create a new zone and move regions from 'Others' to this new zone.<br/>Adjust zones and regions in ",
  'CONTACT.REPORT.FILTERS.REGION.GO.C': 'Region management',
  'CONTACT.REPORT.FILTERS.REGION.GO.R': '.',
  'CONTACT.REPORT.FILTERS.LANG': 'Language',
  'CONTACT.REPORT.FILTERS.MY.NO.LANG': 'No Language here',
  'CONTACT.REPORT.FILTERS.ATTRIBUTE': 'Attribute',
  'CONTACT.REPORT.FILTERS.MY.NO.ATTRIBUTE': 'No Attribute here',
  'CONTACT.REPORT.FILTERS.ATTRIBUTE.CHILDREN.ALL.OR.AND.DESC':
    'Select relevant option(s)',
  'CONTACT.REPORT.FILTERS.MY.NO.TAG': 'No Tag here',
  'CONTACT.REPORT.FILTERS.TAG.EMPTY.TEXT': 'No Tag here, Please create',
  'CONTACT.REPORT.FILTERS.MY.NO.SEGMENT': 'No Segment here',
  'CONTACT.REPORT.FILTERS.SEGMENT.EMPTY.TEXT': 'No Segment here, Please create',
  'CONTACT.REPORT.FILTERS.SAVE': 'Save',
  'CONTACT.REPORT.FILTERS.SAVE.TIPS': 'Maximum quantity reached',
  'CONTACT.REPORT.FILTERS.NAME': 'Filter name',
  'CONTACT.REPORT.FILTERS.NAME.LIMIT':
    'Please enter a filter name with a maximum of {num} characters.',
  'CONTACT.REPORT.FILTERS.SAVE.SUCCESS': 'Successfully saved',
  'CONTACT.REPORT.FILTERS.PREFERENCE.ALL.TIP':
    'Includes contacts who match all selected preferences.',
  'CONTACT.REPORT.FILTERS.PREFERENCE.ANY.TIP':
    'Includes contacts who match at least 1 selected preference.',
  'CONTACT.REPORT.FILTERS.ATTRIBUTE.ALL.TIP':
    'Includes contacts who match all selected attributes.',
  'CONTACT.REPORT.FILTERS.ATTRIBUTE.ANY.TIP':
    'Includes contacts who match at least 1 selected attribute.',
  'CONTACT.REPORT.KEY.METRICS': 'Key metrics',
  'CONTACT.REPORT.CONTACTS': 'New Contacts',
  'CONTACT.REPORT.CONTACTS.LOADING': 'Contacts loading...',
  'CONTACT.REPORT.SUBSCRIBERS': 'New  subscribers',
  'CONTACT.REPORT.SUBSCRIBERS.RATE': 'Subscribe Rate',
  'CONTACT.REPORT.SUBSCRIBERS.LOADING': 'Subscribers loading...',
  'CONTACT.REPORT.ENGAGEMENT.LEVEL.AVG.DESC': 'Average rating',
  'CONTACT.REPORT.CONTACTS.TREND': 'Contact trend',
  'CONTACT.REPORT.ACCUMULATED': 'All',
  'CONTACT.REPORT.SUBSCRIBED': 'Subscribed',
  'CONTACT.REPORT.UNSUBSCRIBE': 'Unsubscribed',
  'CONTACT.REPORT.NON.SUBSCRIBE': 'Non-subscribed',
  'CONTACT.REPORT.PENDING': 'Pending',
  'CONTACT.REPORT.CONTACTS.DIST': 'Contact distribution',
  'CONTACT.REPORT.PREFERENCE': 'Preference',
  'CONTACT.REPORT.SOURCES': 'Source',
  'CONTACT.REPORT.SOURCES.SWITCH': 'Only count by the first source ',
  'CONTACT.REPORT.SUBSCRIPTION': 'Subscription',
  'CONTACT.REPORT.LANGUAGES': 'Language',
  'CONTACT.REPORT.LOCATIONS': 'Region',
  'CONTACT.REPORT.LOCATIONS.ZONES.TITLE': 'Zones',
  'CONTACT.REPORT.LOCATIONS.ZONES.GO.REGION.MANAGE.L':
    'Adjust zones and regions in ',
  'CONTACT.REPORT.LOCATIONS.ZONES.GO.REGION.MANAGE.C': 'Region management',
  'CONTACT.REPORT.LOCATIONS.ZONES.GO.REGION.MANAGE.R': '.',
  'CONTACT.REPORT.NO.DATA': 'No data here',
  'CONTACT.REPORT.LOCATIONS.ZONES.TITLE': 'Zones',
  'CONTACT.REPORT.LOCATIONS.ZONES.GO.REGION.MANAGE.L':
    'Adjust zones and regions in ',
  'CONTACT.REPORT.LOCATIONS.ZONES.GO.REGION.MANAGE.C': 'Region management',
  'CONTACT.REPORT.LOCATIONS.ZONES.GO.REGION.MANAGE.R': '.',
  'CONTACT.REPORT.PREFERENCE.MORE': 'Learn more',
  'CONTACT.REPORT.ECHARTS.MAP.HEIGHT': 'High',
  'CONTACT.REPORT.ECHARTS.MAP.LOW': 'Low',
  'CONTACT.REPORT.SUBSCRIBED.CONTACTS': 'Subscribed contacts',
  'CONTACT.REPORT.UN.SUBSCRIBED.CONTACTS': 'Unsubscribed contacts',
};
